import React, { useState } from 'react';
import { PageHeader, PillButton, Stack } from 'library/ui';
import JobCardList from './JobCardList';
import { PermissionType, useUserContext } from 'UserContext';
import { AddPaymentMethodModal } from 'shared/payments';

const UpcomingJobsPage = () => {
    const [paymentSetupModalOpen, setPaymentSetupModalOpen] = useState(false);
    const { user, role, hasPermission, refreshAlreadyLoggedInUser } = useUserContext();

    if (role !== 'business_active') return null;

    const paymentSetupNeeded = !user?.is_manual_payer && (user?.payment_information?.length ?? 0) === 0;
    const canManagePayments = hasPermission(PermissionType.ManagePayments);
    const showSetupTandemPay = paymentSetupNeeded && canManagePayments;

    return (
        <Stack gap="md">
            <PageHeader
                title="Jobs"
                actions={
                    showSetupTandemPay ? (
                        <PillButton onClick={() => setPaymentSetupModalOpen(true)}>Set up TandemPay</PillButton>
                    ) : undefined
                }
            />
            <JobCardList />
            {showSetupTandemPay && (
                <AddPaymentMethodModal
                    open={paymentSetupModalOpen}
                    onClose={() => setPaymentSetupModalOpen(false)}
                    onSuccess={() => refreshAlreadyLoggedInUser()}
                />
            )}
        </Stack>
    );
};

export default UpcomingJobsPage;
